import { useState } from 'react';
import Page from '@components/Pages/Page';
import { Pages } from '@lib/constants';
import SessionDetails from './SessionDetails';

const SessionDetailsPage = () => {
  const [title, setTitle] = useState('');

  return (
    <Page
      pageId={Pages.SESSION_DETAILS}
      navPhoto={{ image: '/images/activities/left_sidebar.jpg' }}
      title={title}
      breadcrumbs={['events', ':event', ':session']}
      requireAuth
    >
      <SessionDetails setTitle={setTitle} />
    </Page>
  )
};

export default SessionDetailsPage;
